const STORAGE_KEY = "tidal-theme-preview";
const DEFAULT_THEME_NAME = "Theme";
export {
  DEFAULT_THEME_NAME,
  STORAGE_KEY
};
//# sourceMappingURL=constants.js.map
